import { Tooltip } from "antd";
import { ReactNode, useState } from "react";

interface DatastoreLabelProps {
  name: ReactNode;
}

const DatastoreLabel = ({ name }: DatastoreLabelProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip open={isOpen} title={name} placement="right">
      <span
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}>
        {name}
      </span>
    </Tooltip>
  );
};

export default DatastoreLabel;
